import request from 'superagent';
import store from './store';
import config from './config';

export default {
  request(method, path, authenticated) {
    const lowerMethod = method.toLowerCase();
    const authToken = store.get('authToken');
    const res = request[lowerMethod](config.baseUrl + path);
    if (authenticated) {
      res.set('Authorization', `token ${authToken}`);
      const idToken = store.get('idToken');
      if (idToken) res.set('x-id-token', idToken);
    }
    return res;
  },
};



// WEBPACK FOOTER //
// ./src/lib/client.js